import { MAX_INTEGER, MIN_INTEGER } from '../config/constants';
import { isNil } from 'lodash';

/**
 * checking if value is positive interge (exclude 0)
 * @param value: either number or null
 */
export const isPositiveIntegerLargerThanZero = (value: number | null) => {
  if (isNil(value)) {
    return false;
  }
  return value > 0 && !value.toString().includes('.');
};

/**
 * check if value is positive number or zero
 * @param value: either number or null
 */
export const isNumberLargerThanOrEqualToZero = (value: number | null) => {
  if (isNil(value)) {
    return false;
  }
  return value >= 0;
};

// validate a number given the min, max, and precision
export const isValidNumberWithinRange = (
  numValue?: number | null,
  min?: number,
  max?: number,
  precision?: number,
) => {
  if (isNil(numValue)) {
    return false;
  }

  if (
    !isNil(precision) &&
    countDigitsAfterDecimal(numValue.toString()) > precision
  ) {
    return false;
  }

  const localMax = isNil(max) ? MAX_INTEGER : max;
  const localMin = isNil(min) ? MIN_INTEGER : min;

  return numValue >= localMin && numValue <= localMax;
};

// counts the number of digits in a floating point number.
// eg. 1.234 => 3
export const countDigitsAfterDecimal = (numberString: string) => {
  const decimalIndex = numberString.indexOf('.');
  return decimalIndex === -1 ? 0 : numberString.length - decimalIndex - 1;
};
